interface StatCardProps {
  value: string | number
  label: string
  iconSrc: string
  iconAlt: string
}

const StatCard = ({ value, label, iconSrc, iconAlt }: StatCardProps) => {
  return (
    <div className="flex flex-col gap-2 bg-white dark:bg-[#1D1E20] border border-gray-200 dark:border-transparent px-3 h-[96px] py-2 rounded-lg">
      <div className="flex justify-between h-full">
        <div className="flex flex-col justify-end h-full">
          <span className="text-[32px] font-bold text-gray-900 dark:text-white">{value}</span>
          <p className="text-sm font-light text-gray-600 dark:text-gray-300">{label}</p>
        </div>
        <div className="flex items-center gap-2">
          <img alt={iconAlt} src={iconSrc} />
        </div>
      </div>
    </div>
  )
}

export default StatCard
